import { CLASS_NAMES } from "../../utils/constants"
import GameObject from "./GameObject"

export default class Empty extends GameObject {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: false,
      isFlat: true,
      isPickable: false,
      isCrushable: true,
      level
    })
    this.id = id
    this.level = level
    this.isEmpty = true
  }
  setPosition(coords) {
    this.position = coords
  }
}

Empty.className = CLASS_NAMES.EMPTY
